var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosesmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4964 12.5107C20.7745 12.2326 20.7745 11.7817 20.4964 11.5036C20.2183 11.2255 19.7674 11.2255 19.4893 11.5036L16 14.9929L12.5107 11.5036C12.2326 11.2255 11.7817 11.2255 11.5036 11.5036C11.2255 11.7817 11.2255 12.2326 11.5036 12.5107L14.9929 16L11.5036 19.4893C11.2255 19.7674 11.2255 20.2183 11.5036 20.4964C11.7817 20.7745 12.2326 20.7745 12.5107 20.4964L16 17.0071L19.4893 20.4964C19.7674 20.7745 20.2183 20.7745 20.4964 20.4964C20.7745 20.2183 20.7745 19.7674 20.4964 19.4893L17.0071 16L20.4964 12.5107Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosesmall);
export default __webpack_public_path__ + "static/media/close small.2e55591c30b51d8eb3418b4f339d336b.svg";
export { ForwardRef as ReactComponent };